import { render, staticRenderFns } from "./ReadingTask5.vue?vue&type=template&id=0be8fef3&scoped=true&"
import script from "./ReadingTask5.vue?vue&type=script&lang=ts&"
export * from "./ReadingTask5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8fef3",
  null
  
)

export default component.exports